module.exports = __webpack_public_path__ + "static/media/waiting woman.c4c656fa.png";